export interface ActionDeadline {
  dateStart: string
  deadline: string
  dateStartTime?: string
  deadlineTime?: string
}

export const statsTimelineEn = {
  goToTask: 'Go to task',
  monthNames: [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'June',
    'July',
    'Aug',
    'Sept',
    'Oct',
    'Nov',
    'Dec'
  ],
  filteringTable: 'Filtering a table',
  filteringEvents: 'Filtering events',
  download: 'Download as a table',
  dateTime: 'Date / Time',
  action: 'Action',
  initiator: 'Initiator',
  location: 'Location',
  task: 'Task',
  fromTo: (from: string, to: string) => `from “${from}” to “${to}”`,
  filteringTheEventFeed: 'Filtering events',
  clearFilters: 'Clear filters',
  taskLocation: 'Task location',
  eventDate: 'Event date',
  user: 'User',
  statActionAdding: 'Adding',
  statActionDeleting: 'Deleting',
  statActionRecovery: 'Recovery',
  statActionRenaming: 'Renaming',
  statActionMoving: 'Moving',
  statActionArchiving: 'Archiving',
  statActionUnzipping: 'Unzipping',
  statActionDone: 'Done',
  statActionUnDone: 'Undone',
  statActionString: 'Changing stickers with states',
  statActionNumeric: 'Change sticker with a number',
  statActionText: 'Change sticker with text',
  statActionSprint: 'Changing interval stickers',
  statActionMessage: 'Message in the task',
  statActionAddingUserToProject: 'Adding a user to the project',
  statActionRemovingUserFromProject: 'Removing a user from a project',
  statActionChangingRoles: 'Changing roles in a project',
  statActionChangePermissions: 'Changing permissions in a project',
  statActionAddingUser: 'Adding a user to the company',
  statActionRemovingUser: 'Removing a user from a company',
  statActionFiles: 'Uploading files',
  statObjectUsers: 'users',
  statActionAddUserToProject: (project: string) =>
    `Added to the project “${project}” user`,
  statActionAddUsersToProject: (project: string) =>
    `Added to the project “${project}” users`,
  statActionRemoveUserFromProject: (project: string) =>
    `Removed from the project “${project}” user`,
  statActionRemoveUsersFromProject: (project: string) =>
    `Removed from the project “${project}” users`,
  statActionChangeRolesInProject: (project: string) =>
    `Roles changed in the project “${project}”`,
  statActionChangePermissionsInProject: (project: string) =>
    `Changed user rights in the project “${project}”`,
  statActionExecutor: 'Assign executor',
  statActionChangeExecutors: (users: string[]) =>
    `Users ${users.join(', ')} were assigned to the task`,
  statActionChangeExecutor: (user: string) =>
    `User ${user} was assigned to the task`,
  statActionChangeExecutorEmpty: 'Assigned users was removed',

  statActionRemoveString: (name: string, value: string) =>
    `Removed value ${value} for the sticker: ${name}`,
  statActionSetString: (name: string, value: string) =>
    `Set value ${value} for the sticker: ${name}`,
  statActionChangeString: (name: string, oldValue: string, newValue: string) =>
    `Sticker ${name} changed from ${oldValue} to ${newValue}`,
  statActionDetachedString: (name: string) =>
    `Sticker ${name} detached from the task`,
  statActionAttachedString: (name: string) =>
    `Sticker ${name} attached to the task`,

  statActionSetDeadlineOne: (date: string, time?: string) =>
    `Deadline set for the task: ${date}${time ? ' к ' + time : ''}`,
  statActionSetDeadlineTwo: ({
    dateStart,
    deadline,
    deadlineTime
  }: ActionDeadline) =>
    `Deadline set for the task ${dateStart} - ${deadline}${
      deadlineTime ? ' к ' + deadlineTime : ''
    }`,

  statActionChangeDeadlineTwoTime: (
    oldDt: ActionDeadline,
    newDt: ActionDeadline
  ) =>
    `Deadline was changed since ${getDeadlineTime(oldDt)} to ${getDeadlineTime(
      newDt
    )}`,
  statActionDetachedDeadline: 'Deadline detached from the task',
  statActionAttachedDeadline: 'Deadline attached to the task',
  statActionDeadline: 'Change deadline',

  statActionSetTimeTrackerSet: (plan: string, work: string) =>
    `Timetracker set plan: ${plan}, work: ${work}`,

  statActionSetTimeTrackerChange: (
    prevPlan: string,
    currPlan: string,
    prevWork: string,
    currWork: string
  ) =>
    `Timetracker changed plan from ${prevPlan} to ${currPlan}, work from ${prevWork} to ${currWork}`,

  statActionSetTimeTrackerSetPlan: (value: string) =>
    `Set plan to execute the task: ${value}`,
  statActionSetTimeTrackerChangePlan: (prev: string, current: string) =>
    `Changed plat to execute the task from ${prev} to ${current}`,

  statActionSetTimeTrackerSetWork: (value: string) =>
    `Set the actual time to complete the task: ${value}`,
  statActionSetTimeTrackerChangeWork: (prev: string, current: string) =>
    `Changed the actual time to complete the task from ${prev} to ${current}`,
  statActionAttachedTimetracker: 'Timetracker attached to the task',
  statActionDetachedTimetracker: 'Timetracker detached from the task',
  statActionTimetracker: 'Timetracker changes',

  statActionStopwatchRun: 'Stopwatch run',
  statActionStopwatchRunValue: (value: string) => `Stopwatch run at ${value}`,
  statActionStopwatchStop: (value: string) =>
    `Stopwatch stop. The value: ${value}`,

  statActionStopwatchDetached: `Stopwatch detached from the task`,
  statActionStopwatch: 'Stopwatch changes',

  statActionTimerInited: (value: string) => `Timer set: ${value}`,
  statActionTimerSet: (value: string) => `Timer set: ${value}`,
  statActionTimerStop: (value: string) => `Timer stopped: ${value} `,
  statActionTimerChanged: (prev: string, curr: string) =>
    `Timer changed from ${prev} to ${curr}`,
  statActionTimerAttached: 'Timer attached to the task',
  statActionTimerDetached: `Timer detached from the task`,
  statActionTimer: 'Timer changes',

  statActionRepeatTemplateChanged: 'Repeat template is changed',

  statActionAddUser: 'Adding a user to the company',
  statActionRemoveUser: 'Removing a user from a company',
  statActionAddUserToCompany: `Added to the company user`,
  statActionAddUsersToCompany: `Added to the company users`,
  statActionRemoveUserFromCompany: `Removed from the company user`,
  statActionRemoveUsersFromCompany: `Removed from the company users`,
  statActionAttachedFile: 'Attached file',
  statActionAttachedFiles: 'Attached files',
  showMore: 'Show more...',
  items: 'items',
  restoreTask: 'Restore task',
  restoreProject: 'Restore project',
  restoreBoard: 'Restore board',
  restoreColumn: 'Restore column',
  restoredTask: 'Task restored',
  restoredProject: 'Project restored',
  restoredBoard: 'Board restored',
  restoredColumn: 'Column restored',
  dissallowedToRestore: 'You have no permissions to restore this object',
  subtask: 'subtask',
  column1: 'column',
  column2: 'columns',
  column3: 'columns',
  saveChanges: 'Save changes',
  removeFilter: 'Remove filter',
  saveAsNewFilter: 'Save as new filter',
  saveFilter: 'Save filter',
  reset: 'reset',
  savedFilters: 'Saved Filters',
  removeThisFilter: 'Remove this filter?',
  recoveryIsImpossible: 'Recovery is impossible',
  yesDelete: 'Yes, delete',
  cancel: 'Cancel',
  deletedObjects: 'Deleted objects',
  uploadedFiles: 'Uploaded files',
  communicationByTasks: 'Communication by tasks',
  empty: 'No events found',
  where: 'Where',
  who: 'Who',
  when: 'When',
  actions: 'Actions',
  filterName: 'Filter name',
  enterNameOfFilter: 'Enter the name of the filter',
  anyProject: 'Any project',
  any: 'Any',
  anyDate: 'Any date',
  allActions: 'All actions',
  allUsers: 'All users',
  inaccessibleLocation: 'Inaccessible location',
  actionWasTakenBy: 'The action was taken by',
  statActionCompleteProject: 'Archived project',
  statActionCompleteTask: 'Archived task',
  statActionUncompleteProject: 'Unarchived project',
  statActionUncompleteTask: 'Unarchived task',
  message: 'Message',
  taskCompleted: 'Task completed'
}

export const statsTimelineRu: typeof statsTimelineEn = {
  goToTask: 'Перейти к задаче',
  monthNames: [
    'Янв',
    'Фев',
    'Мар',
    'Апр',
    'Мая',
    'Июня',
    'Июля',
    'Авг',
    'Сент',
    'Окт',
    'Ноя',
    'Дек'
  ],
  filteringTable: 'Фильтрация таблицы',
  filteringEvents: 'Фильтрация событий',
  download: 'Скачать таблицей',
  dateTime: 'Дата / время',
  action: 'Действие',
  initiator: 'Инициатор',
  location: 'Расположение',
  task: 'Задача',
  fromTo: (from: string, to: string) => `из “${from}” в “${to}”`,
  filteringTheEventFeed: 'Фильтрация событий',
  clearFilters: 'Сбросить фильтры',
  taskLocation: 'Расположение задачи',
  eventDate: 'Дата события',
  user: 'Пользователь',
  statActionAdding: 'Добавление',
  statActionDeleting: 'Удаление',
  statActionRecovery: 'Восстановление',
  statActionRenaming: 'Переименование',
  statActionMoving: 'Перемещение',
  statActionArchiving: 'Архивирование',
  statActionUnzipping: 'Разархивирование',
  statActionDone: 'Выполнение',
  statActionUnDone: 'Отмена выполнения',
  statActionString: 'Изменение стикера с состояниями',
  statActionNumeric: 'Изменение стикера с числовым полем',
  statActionText: 'Изменение стикера с текстовым полем',
  statActionSprint: 'Изменение стикера спринт',
  statActionMessage: 'Сообщение в задаче',
  statActionAddingUserToProject: 'Добавление пользователя в проект',
  statActionRemovingUserFromProject: 'Удаление пользователя с проекта',
  statActionChangingRoles: 'Изменение ролей в проекте',
  statActionChangePermissions: 'Изменение разрешений в проекте',
  statActionAddingUser: 'Добавление пользователя в компанию',
  statActionRemovingUser: 'Удаление пользователя из компании',
  statActionFiles: 'Загрузка файлов',
  statObjectUsers: 'пользователей',
  statActionAddUserToProject: (project: string) =>
    `Добавлен в проект “${project}” пользователь`,
  statActionAddUsersToProject: (project: string) =>
    `Добавлены в проект “${project}” пользователи`,
  statActionRemoveUserFromProject: (project: string) =>
    `Удалён из проекта “${project}” пользователь`,
  statActionRemoveUsersFromProject: (project: string) =>
    `Удалены из проекта “${project}” пользователи`,
  statActionChangeRolesInProject: (project: string) =>
    `Изменены роли в проекте “${project}”`,
  statActionChangePermissionsInProject: (project: string) =>
    `Изменены права пользователей в проекте “${project}”`,
  statActionExecutor: 'Назначение исполнителя',
  statActionChangeExecutors: (users: string[]) =>
    `Пользователи ${users.join(', ')} назначены исполнителями задачи`,
  statActionChangeExecutor: (user: string) =>
    `Пользователь ${user} назначен(а) исполнителем задачи`,
  statActionChangeExecutorEmpty: 'Исполнители удалены',

  statActionRemoveString: (name: string, value: string) =>
    `Удалено значение ${value} стикера ${name}`,
  statActionSetString: (name: string, value: string) =>
    `Установлено значение ${value} стикера ${name}`,
  statActionChangeString: (name: string, oldValue: string, newValue: string) =>
    `Значение стикера ${name} изменено с ${oldValue} на ${newValue}`,
  statActionDetachedString: (name: string) =>
    `Стикер ${name} откреплен от задачи`,
  statActionAttachedString: (name: string) =>
    `Стикер ${name} прикреплен к задаче`,

  statActionSetDeadlineOne: (date: string, time?: string) =>
    `Выставлен дедлайн по задаче: ${date}${time ? ' к ' + time : ''}`,
  statActionSetDeadlineTwo: ({
    dateStart,
    deadline,
    deadlineTime
  }: ActionDeadline) =>
    `Выставлен дедлайн по задаче ${dateStart} - ${deadline}${
      deadlineTime ? ' к ' + deadlineTime : ''
    }`,

  statActionChangeDeadlineTwoTime: (
    oldDt: ActionDeadline,
    newDt: ActionDeadline
  ) => {
    return `Дедлайн был изменен с ${getDeadlineTime(
      oldDt
    )} на ${getDeadlineTime(newDt)}`
  },

  statActionDetachedDeadline: 'Дедлайн откреплен от задачи',
  statActionAttachedDeadline: 'Дедлайн прикреплен к задаче',
  statActionDeadline: 'Изменение дедлайна',

  statActionSetTimeTrackerSet: (plan: string, work: string) =>
    `Таймтрекер установлен плановое время: ${plan}, фактическое время: ${work}`,

  statActionSetTimeTrackerChange: (
    prevPlan: string,
    currPlan: string,
    prevWork: string,
    currWork: string
  ) =>
    `Таймтрекер изменен плановое время с ${prevPlan} на ${currPlan}, фактическое время с ${prevWork} на ${currWork}`,

  statActionSetTimeTrackerSetPlan: (value: string) =>
    `Установлено плановое время на выполнение задачи: ${value}`,
  statActionSetTimeTrackerChangePlan: (prev: string, current: string) =>
    `Изменено плановое время выполнения задачи с ${prev} на ${current}`,

  statActionSetTimeTrackerSetWork: (value: string) =>
    `Установлено фактическое время на выполнение задачи: ${value}`,
  statActionSetTimeTrackerChangeWork: (prev: string, current: string) =>
    `Изменено фактическое время выполнения задачи с ${prev} на ${current}`,
  statActionAttachedTimetracker: 'Таймтрекер прикреплен к задаче',
  statActionDetachedTimetracker: 'Таймтрекер откреплен от задачи',
  statActionTimetracker: 'Изменение таймтрекера',

  statActionStopwatchRun: 'Запущен секундомер',
  statActionStopwatchRunValue: (value: string) =>
    `Секундомер снят с паузы. Значение: ${value}`,
  statActionStopwatchStop: (value: string) =>
    `Секундомер поставлен на паузу. Значение: ${value}`,
  statActionStopwatchDetached: `Секундомер откреплен от задачи`,
  statActionStopwatch: 'Изменение секундомера',

  statActionTimerInited: (value: string) => `Таймер установлен: ${value}`,
  statActionTimerSet: (value: string) => `Таймер снят с паузы: ${value}`,
  statActionTimerStop: (value: string) =>
    `Таймер поставлен на паузу: ${value} `,
  statActionTimerChanged: (prev: string, curr: string) =>
    `Таймер изменен c ${prev} на ${curr}`,
  statActionTimerAttached: 'Таймер прикреплен к задаче',
  statActionTimerDetached: `Таймер откреплен от задачи`,
  statActionTimer: 'Изменение таймера',

  statActionRepeatTemplateChanged: 'Шаблон регулярной задачи изменен',

  statActionAddUser: 'Добавление пользователя в компанию',
  statActionRemoveUser: 'Удаление пользователя из компании',
  statActionAddUserToCompany: `Добавлен в компанию пользователь`,
  statActionAddUsersToCompany: `Добавлены в компанию пользователи`,
  statActionRemoveUserFromCompany: `Удалён из компании пользователь`,
  statActionRemoveUsersFromCompany: `Удалены из компании пользователи`,
  statActionAttachedFile: 'Прикреплён файл',
  statActionAttachedFiles: 'Прикреплены файлы',
  showMore: 'Показать ещё...',
  items: 'шт.',
  restoreTask: 'Восстановить задачу',
  restoreProject: 'Восстановить проект',
  restoreBoard: 'Восстановить доску',
  restoreColumn: 'Восстановить колонку',
  restoredTask: 'Задача восстановлена',
  restoredProject: 'Проект восстановлен',
  restoredBoard: 'Доска восстановлена',
  restoredColumn: 'Колонка восстановлена',
  dissallowedToRestore: 'У вас нет прав на восстановление этого объекта',
  subtask: 'подзадача',
  column1: 'колонка',
  column2: 'колонки',
  column3: 'колонок',
  saveChanges: 'Сохранить изменения',
  removeFilter: 'Удалить фильтр',
  saveAsNewFilter: 'Сохранить как новый фильтр',
  saveFilter: 'Сохранить фильтр',
  reset: 'сбросить',
  savedFilters: 'Сохранённые фильтры',
  removeThisFilter: 'Удалить этот фильтр?',
  recoveryIsImpossible: 'Восстановление невозможно',
  yesDelete: 'Да, удалить',
  cancel: 'Отмена',
  deletedObjects: 'Удалённые объекты',
  uploadedFiles: 'Загруженные файлы',
  communicationByTasks: 'Общение по задачам',
  empty: 'Не найдено событий',
  where: 'Где',
  who: 'Кто',
  when: 'Когда',
  actions: 'Действия',
  filterName: 'Название фильтра',
  enterNameOfFilter: 'Введите название фильтра',
  anyProject: 'Все проекты',
  any: 'Любая',
  anyDate: 'Любая дата',
  allActions: 'Все действия',
  allUsers: 'Все пользователи',
  inaccessibleLocation: 'Недоступное расположение',
  actionWasTakenBy: 'Действие совершил',
  statActionCompleteProject: 'Проект перенесен в архив',
  statActionCompleteTask: 'Задача перенесена в архив',
  statActionUncompleteProject: 'Проект восстановлен из архива',
  statActionUncompleteTask: 'Задача восстановлена из архива',
  message: 'Сообщение',
  taskCompleted: 'Задача выполнена'
}

const getDeadlineTime = ({
  dateStart,
  deadline,
  dateStartTime,
  deadlineTime
}: ActionDeadline): string => {
  const end = `${deadline}${deadlineTime ? ' ' + deadlineTime : ''}`

  if (!dateStart) {
    return end
  }

  const start = `${dateStart}${dateStartTime ? ' ' + dateStartTime : ''}`
  return `${start} - ${end}`
}
